import { IsoIntervalStr } from '@elderbyte/ngx-starter'
import { WeekSchedule, WorkSchedule } from '../../../schedules/work-schedule'

export class WorkCenterSchedule extends WorkSchedule {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public id?: string // ObjectId

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor(
    /**
     * The WorkCenter
     */
    public workCenterId: string,
    public override name: string,
    /**
     * The scope in which this performance schedule is applicable.
     */
    public override validityInterval: IsoIntervalStr,
    /**
     * The week schedule
     */
    public override weekSchedule: WeekSchedule = new WeekSchedule()
  ) {
    super(name, validityInterval, weekSchedule)
  }
}
